import { Button, CheckboxDropdown, DownloadIcon, SlidersIcon, Toolbar, Tooltip } from '@exxonmobil/react-unity';
import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import dayjs from 'dayjs';
import { Column } from '../types/Column';
import { EndpointData } from '../types/EndpointData';
import { EndpointCsvData, getCsvData } from '../utils/getCsvData';
import { CsvHeader, getCsvHeader } from '../utils/getCsvHeader';
import { DATE_FORMAT } from '../../common/date';

interface Props {
  columns: Column[];
  data: EndpointData[];
  onChangeFilter: Function;
}

export const ToolbarHeader = ({ columns, onChangeFilter, data }: Props) => {
  const [csvHeader, setCsvHeader] = useState<CsvHeader[]>([]);
  const [csvData, setCsvData] = useState<EndpointCsvData[]>([]);

  return (
    <Toolbar style={{ backgroundColor: 'white' }}>
      <Toolbar.Item>
        <CheckboxDropdown
          id="column-dropdown-button"
          label={<SlidersIcon size="medium" />}
          buttonProps={{ size: 'small' }}
        >
          {columns.map((column) => (
            <CheckboxDropdown.Item
              key={column.name}
              label={column.name}
              inputProps={{ defaultChecked: column.checked, disabled: column.disabled }}
              onChange={() => onChangeFilter(column.name, !column.checked)}
            />
          ))}
        </CheckboxDropdown>
      </Toolbar.Item>
      <Toolbar.Item right style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Tooltip>
          <Tooltip.Passage>
            <CSVLink
              data={csvData}
              headers={csvHeader}
              filename={`endpoints-${dayjs().format(DATE_FORMAT)}`}
              target="_blank"
            >
              <Button
                className="em-u-margin-half"
                variant="primary"
                color="main"
                size="small"
                style={{ width: '2.5rem' }}
                onClick={() => {
                  setCsvData(getCsvData(data));
                  setCsvHeader(getCsvHeader(columns));
                }}
              >
                <DownloadIcon size="small" style={{ padding: 0, width: '1rem', height: '1rem' }} />
              </Button>
            </CSVLink>
          </Tooltip.Passage>

          <Tooltip.Content style={{ marginBottom: '-1rem' }}>Export as csv.</Tooltip.Content>
        </Tooltip>
      </Toolbar.Item>
    </Toolbar>
  );
};
